<div class="slider-container" [class.has-icon-thumb]="!!options.thumbIcon">
  <mat-slider
    [min]="options.minValue"
    [max]="options.maxValue"
    [step]="1"
    showTickMarks
    discrete
    class="slider-track-{{ options.sliderTrackColor }}"
    [class.slider-gradient]="!!options.trackGradient"
    [class.slider-dots]="options.trackDots"
    [style.--track-bg]="options.trackGradient"
    [style.--dot-bg]="options.dotColor"
  >
    <input
      matSliderThumb
      [(ngModel)]="selectedValue"
      (ngModelChange)="onValueChange($event)"
      #slider="matSliderThumb"
    />
    <!-- Score variant: icon thumb (star / cloud) with the value centred inside -->
    <app-star-with-number
      *ngIf="options.thumbIcon; else asteriskThumb"
      (click)="toggleValue()"
      class="slider-value-custom"
      [class.is-zero]="selectedValue === 0"
      [style.left]="thumbLeft"
      [icon]="options.thumbIcon"
      [number]="selectedValue === 0 ? '' : selectedValue"
      [numberColor]="options.thumbNumberColor || 'var(--color-evergreen)'"
      [iconSize]="selectedValue === 0 ? 1.5 : (options.thumbIconSize || 2.25)"
      [numberSize]="1.125"
    ></app-star-with-number>
    <!-- Default variant: asterisk thumb (unchanged for existing callers) -->
    <ng-template #asteriskThumb>
      <app-asterisk-with-number
        (click)="toggleValue()"
        class="slider-value-custom"
        [class.is-zero]="selectedValue === 0"
        [style.left]="thumbLeft"
        [number]="selectedValue === 0 ? '' : selectedValue"
        [asteriskColor]="options.customThumbColor"
        [asteriskSize]="selectedValue === 0 ? 0.875 : 1.875"
      ></app-asterisk-with-number>
    </ng-template>
  </mat-slider>
</div>
